import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel } from '@mui/material';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

function CustomOverlay({
  classNames, selectedDay, children, ...props
}) {
  return (
    <div
      style={{ height: 250 }}
      {...props}
    >
      <div className={classNames.overlay}>
        {children}
      </div>
    </div>
  );
}

function DateRangeFilterSingle({
  filterList,
  onChange,
  index,
  column,
  label,
  filterArrayIndex,
}) {
  return (
    <FormControlLabel
      label={label}
      labelPlacement="top"
      control={(
        <DayPickerInput
          formatDate={formatDate}
          parseDate={parseDate}
          placeholder={`${formatDate(new Date())}`}
          overlayComponent={CustomOverlay}
          keepFocus={false}
          inputProps={{ style: { width: '150%' }, readOnly: true }}
          value={
        filterList[index][filterArrayIndex]
          ? formatDate(filterList[index][filterArrayIndex])
          : ''
      }
          onDayChange={(day) => {
            // eslint-disable-next-line no-param-reassign
            filterList[index][filterArrayIndex] = day;
            onChange(filterList[index], index, column);
          }}
        />
)}
    />
  );
}

DateRangeFilterSingle.propTypes = {
  filterList: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.any)),
  onChange: PropTypes.func,
  index: PropTypes.number,
  filterArrayIndex: PropTypes.number,
  label: PropTypes.string,
  column: PropTypes.objectOf(PropTypes.any),
};

DateRangeFilterSingle.defaultProps = {
  filterList: [],
  onChange: () => {},
  index: 0,
  filterArrayIndex: 0,
  column: {},
  label: '',
};

export default DateRangeFilterSingle;
